import axios from 'axios';

const api = axios.create();

const kernelApi = (command, docId, extraData) =>
  api({
    method: 'post',
    url: `/api/v1/kernel/${command}`,
    data: {
      docId,
      ...extraData,
    },
  });

export const getRevs = (docId) =>
  api({
    method: 'get',
    url: `/api/v1/revs/${docId}`,
  });

export const restartKernel = (docId) => kernelApi('restart', docId);

export const ensureKernel = (docId, usageInfo) =>
  kernelApi('ensure', docId, { usageInfo });

export const getFileUploadDestination = (filename, contentType) =>
  api({
    method: 'post',
    url: '/api/v1/create-file-upload',
    data: {
      filename,
      contentType,
    },
  });

export const deleteFile = (filename) =>
  api({
    method: 'post',
    url: '/api/v1/delete-file-upload',
    data: { filename },
  });

export const heartbeatKernel = (docId) => kernelApi('heartbeat', docId);

export const destroyKernel = (docId) => kernelApi('destroy', docId);

// Path is an optional initial path that points to the workbook's location in the ShareDB
// document. This is currently only used when the workbook is in "Explore" mode, otherwise
// we default to the base directory and `path` is undefined.
export const runAllCells = (docId, worksheet, path) => {
  kernelApi('runall', docId, { worksheet, path });
};

export const executeCode = (docId, code, path) =>
  kernelApi('execute', docId, { code, path });

export const sendInput = (docId, input) =>
  kernelApi('reply', docId, { content: input });

export const interruptKernel = (docId) => kernelApi('interrupt', docId);

/** Starts up the kernel for a given worksheet, with the ability to override any settings via the optional `usageInfo`.
 * There are edge cases where a kernel can become stuck and unable to start, so this function
 * also interrupts an existing kernel (if it exists) and flushing the queue before the start attempt.
 * This function should never be called when the kernel is already running, as it will affect any in-progress commands
 * the user has sent.
 */
export const startKernel = async (docId, usageInfo) => {
  await interruptKernel(docId);
  await ensureKernel(docId, usageInfo);
};

/** This function interrupts and destroys the existing kernel, and then starts a new kernel
 *  with the given configuration. */
export const changeKernel = async (docId, kernelLang, kernelConfig) => {
  await interruptKernel(docId);
  await destroyKernel(docId);
  await ensureKernel(docId, { kernelLang, kernelConfig });
};

export default api;
